import React from "react";
// used for making the prop types of this component
import PropTypes from "prop-types";

// core components
import Button from "../../components/CustomButtons/Button.jsx";

import {inject, observer} from "mobx-react";
import {toJS} from "mobx";
import {v4 as uuidv4} from "uuid";


@inject('store')
@observer
class ImageUpload extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            file: null,
            imagePreviewUrl: null
            //  imagePreviewUrl: this.props.avatar ? defaultAvatar : defaultImage
        };
        this.store = this.props.store.appState;
        this.handleImageChange = this.handleImageChange.bind(this);
        // this.handleSubmit = this.handleSubmit.bind(this);
        // this.handleClick = this.handleClick.bind(this);
        this.handleRemove = this.handleRemove.bind(this);
    }

    handleImageChange(e) {
        e.preventDefault();
        try {
            let reader = new FileReader();
            let file = e.target.files[0];
            // console.log("File", file);
            reader.onloadend = () => {
                const photo_unique_token = uuidv4();
                // console.log("READER", reader);
                this.setState({
                    file: file,
                    // imagePreviewUrl: reader.result
                    imagePreviewUrl: URL.createObjectURL(file)
                });

                //  console.log("IMAGE PREVIEW", reader.result);
                let fileName = file.name.split(".");
                let ext = fileName.pop();
                let firstVal = fileName.join(".");
                let updatedFileName = firstVal +'_'+ photo_unique_token + '.' + ext;
                let newFile = new File([file], updatedFileName) ;

                this.store.file = newFile;
                this.store.file_name = newFile.name;
                this.store.file_size = newFile.size;
                this.store.error_file_size = false;
            };
            reader.readAsDataURL(file);
        }catch (e) {
            console.log("error:", e);
        }
    }

    // handleSubmit(file) {
    //
    //     // e.preventDefault();
    //
    //     // file.name =firstVal +'_'+ photo_unique_token + '.' + ext;
    //
    //     // this.state.file is the file/image uploaded
    //     // in this function you can save the image (this.state.file) on form submit
    //     // you have to call it yourself
    // }

    // handleClick(e) {
    //     let input = document.createElement("input");
    //     input.accept = "image/*";
    //     input.type = "file";
    //     input.onchange = this.handleImageChange;
    //     input.click();
    // }



    handleRemove() {
        this.setState({file: null,imagePreviewUrl: null});
        this.store.file = null;
        this.store.error_file_size = false;
    }

    render() {

        const DEFAULT_TEXT = toJS(this.store.DEFAULT_TEXT);
        let choosetext = '';

        if(DEFAULT_TEXT.choose_button!==undefined){
            choosetext=DEFAULT_TEXT.choose_button.toUpperCase();
        }

        return (
            <div className="fileinput" style={{display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',marginBottom:'9px'}}>
                
                {/*<div className={"thumbnail" + (this.props.avatar ? " img-circle" : "")} style={this.state.file ? {maxWidth: '10rem', maxHeight: '10rem'} : null}>*/}
                {/*    <img src={this.state.imagePreviewUrl}/>*/}
                {/*</div>*/}

                {
                    this.store.file
                        ?
                            <div className={"thumbnail" + (this.props.avatar ? " img-circle" : "")} style={this.state.file ? {maxWidth: '20rem', width: '17rem'/*, maxHeight: '20rem',  height: '17rem'*/} : null}>
                                <img src={this.state.imagePreviewUrl} alt={'preview'}/>
                            </div>
                        :
                            null
                }

                <div style={{cursor:'pointer',minWidth:'13rem'}}>
                    {
                        this.state.file === null
                            ?
                            (
                                <div>
                                    <label htmlFor="image-upload" style={{color:'white',cursor:"pointer",fontFamily:'Roboto',fontSize:'0.8rem',display:'block', paddingTop: '0.6rem'}}>{choosetext}</label>
                                    <input id='image-upload' type="file" accept="image/*" onChange={(e)=>this.handleImageChange(e)} style={{display:'none'}} />
                                </div>
                            )
                            :
                            (
                                <span style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                                        {/*<Button round color="rose" style={{height: '2rem',width:'5rem'}} onClick={(e) => this.handleChange(e)}> {DEFAULT_TEXT.change_label}</Button>*/}
                                    <Button round color="danger" style={{height: '2rem',width:'5rem'}} onClick={() => this.handleRemove()}> {DEFAULT_TEXT.remove_label} </Button>
                                </span>
                            )
                    }
                </div>
            </div>
        );
    }
}

ImageUpload.propTypes = {
    avatar: PropTypes.bool
};

export default ImageUpload;



// WEBPACK FOOTER //
// ./src/components/CustomUpload/ImageUpload.jsx